import { useRef, useState } from "react"

import HousePilotModalMetrics from "./Modal_Metrics";


export class DeviceBoxManagement {

    switchState() {
        const newStateActive = !this._isActive
        let promise
        if (!newStateActive) {
            promise = this._onStateChange(this._deviceName, 'SET_TEMP', 15.0)
        } else {
            promise = this._onStateChange(this._deviceName, 'SET_TEMP', this._deviceTargetTemperature)
        }

        promise.then(() => {}).catch(() => {})
    }

    changeTemp(direction, value = null) {
        if (this.refChangeTimeout?.current) {
            clearTimeout(this.refChangeTimeout.current)
        }
        const oldTargetTemp = this._deviceTargetTemperature
        let targetTemp = parseFloat(this._deviceTargetTemperature)

        if (value !== null) {
            if (parseFloat(value)) {
                targetTemp = parseFloat(value)
            } else {
                return
            }
        } else {
            if (direction === 'UP') {
                if (!this._isActive) {
                    targetTemp = 16
                } else {
                    targetTemp += 0.5
                }
            } else if (direction === 'DOWN') {
                if (!this._isActive) {
                    return
                }
                targetTemp -= 0.5
            } else {
                return
            }
        }

        const delayChangeTempMs = 600
        const newTargetTemp = targetTemp
        this._setDeviceTargetTemperature(newTargetTemp)


        this.refChangeTimeout.current = setTimeout(() => {
            this._onStateChange(this._deviceName, 'SET_TEMP', newTargetTemp).then(() => {
            }).catch((e) => {
                this._setDeviceTargetTemperature(oldTargetTemp)
            })
        }, delayChangeTempMs)
    }

    getDeviceTargetTempToDisplay() {
        if (this._isActive) {
            return this._deviceTargetTemperature
        } else {
            return '--'
        }
    }

}



export default function HousePilotDeviceBox({ deviceName, deviceLabel, isActive, deviceCurrentTemp, deviceTargetTemp, onStateChange }) {

    const [deviceTargetTpt, setDeviceTargetTpt] = useState(deviceTargetTemp)

    const manager = new DeviceBoxManagement()
    manager._isActive = isActive
    manager._deviceTargetTemperature = deviceTargetTpt
    manager._setDeviceTargetTemperature = setDeviceTargetTpt
    manager.refChangeTimeout = useRef(null)
    manager._deviceName = deviceName
    manager._deviceLabel = deviceLabel
    manager._onStateChange = onStateChange

    const [canShowModalMetrics, setCanShowModalMetrics] = useState(false)

    function onModalCloseHandler() {
        setCanShowModalMetrics(false)
    }

    return (
        <>
            <div className={"m-1  deviceBox " + (manager._isActive ? ' active' : '') + (deviceName.includes('PARENTALE') ? ' col-6 col-md-6' : ' col-6 col-md-3')} id={"device-" + deviceName}>
                <h6>
                    <i className="fa fa-info-circle float-left cursor-pointer" data-dname={deviceName} data-toggle="modal" data-target="#deviceMetrics" onClick={() => setCanShowModalMetrics(true)}></i>
                    <strong className="float-center" style={{ fontSize: "0.85rem" }}>{deviceLabel}</strong>
                    <i className="fa fa-power-off btn-power-switch float-center" onClick={() => { manager.switchState() }}></i>
                    <br />
                </h6>
                <i className="fa fa-temperature-1"></i> <strong className="float-center">{deviceCurrentTemp} °C</strong><br />
                <i className="fa fa-minus-circle cursor-pointer " onClick={() => { manager.changeTemp('DOWN') }}></i> {manager.getDeviceTargetTempToDisplay()} °C
                <i className="fa fa-plus-circle cursor-pointer" onClick={() => { manager.changeTemp('UP') }}></i>
            </div>

            <HousePilotModalMetrics deviceLabel={deviceLabel} deviceName={deviceName} showModal={canShowModalMetrics} onModalClose={onModalCloseHandler} />
        </>
    )
}
